import React from 'react'
import {Link} from "react-router-dom";

export const Help = (props) => (
  <div className="wrap">
      <div className="helppage">
        <h2>＜Genesis2.0検査結果＞ご利用にあたり</h2>

        <p>
          この度はGenesis2.0をご利用いただき誠にありがとうございます。 こちらでは、検査結果の見方や用語の解説などをご紹介しております。
        </p>
        <p>
          ご質問やご意見等ございましたら、下記メールアドレスまでご連絡ください。
        </p>
        <p>お問い合わせMail：<a href="mailto:infogene@genelife.jp">infogene@genelife.jp</a></p>


        <ul className="helppage_menu">
          <li className="help_result"><Link to={{
            pathname: "/help_result",
            state: { referer: "/help" }
          }} onClick={props.switchPageMethod.bind(this, "HelpHow")}>検査結果ページの見方</Link></li>
          <li className="help_qa"><Link to={{
            pathname: "/help_faq",
            state: { referer: "/help" }
          }} onClick={props.switchPageMethod.bind(this, "HelpFaq")}>検査に関するQ&A</Link></li>
          <li className="help_terms"><Link to={{
            pathname: "/help_dictionary",
            state: { referer: "/help" }
          }} onClick={props.switchPageMethod.bind(this, "HelpDic")}>用語集</Link></li>
        </ul>


      </div>

    </div>
)
export const HelpHow = (props) => (
  <div className="wrap">
  <div className="helppage">
    <h2>検査結果ページの見かたについて</h2>

    <h3>グラフについて</h3>
    <p>
      <img src={require("../images/help/help01.png")}/>
    </p>
    <p>赤い吹き出しで示された部分があなたの属する遺伝子タイプになります。 縦軸は遺伝子タイプ別の人口頻度を表しており、棒グラフが高いほど同じ遺伝子タイプを持つ人が多く、低いほど同じ遺伝子タイプが少ないことを表しています。 棒グラフは判定に合わせて色分けされており、自分がどの位置にいるのか（「標準」の中でも「リスクが高い」に近いのかどうかなど）を知ることができます。 なお、このグラフは当社で蓄積している日本人の遺伝子多型データを基にしているため、ここで表示している人口頻度が0%だったとしても、非常に少ない割合で存在している可能性があります。
    </p>

    <h4>Q.山型のグラフや、ガタガタのグラフなど、いろいろな形があるのはどうして？</h4>
    <p>基本的には、日本人の頻度分布がある程度綺麗な山型になるように、区分などの調整を行っています。 しかし、個々の遺伝子が疾患・体質に与える影響力が異なるために、影響力の強い遺伝子が全体の分布を歪めてしまい、山型にならずにガタガタになってしまう場合があります。見苦しく感じる場合もあるかと思いますが、学術論文等を参考に作成されたものですので、ご理解頂けますと幸いです。
    </p>

    <h3>リスク判定について</h3>

    <p>Genesis2.0では日本人の平均的な遺伝子型に対して、あなたの遺伝的リスクが高いか低いかを判定しています。周囲の日本人に比べて、自身がより注意すべきタイプかどうかの参考としてご利用ください。 なお、判定結果について注意して頂きたい点があります。 Genesis2.0では判定基準を日本人の平均に設定しているため、世界的に見れば日本人で発症頻度が高い疾患でも、「（日本人の中では）あなたの遺伝的リスクは低い傾向」と判定される場合があります。
    </p>
    <p>
      <img src={require("../images/help/help02.jpg")}/>
    </p>

    <p>このような場合、他の日本人よりも遺伝的リスクが低い傾向にあったとしても、日本人として、疾患に対する注意は変わらず払うべきであると弊社は考えております。遺伝的な傾向だけではなく、発症年齢や発症率の情報もご参考の上、正しく予防し、適切な生活習慣を心掛けましょう。
    </p>

    <h3>遺伝子説明について</h3>
    <p>この表に記載されている人口頻度は、当社で蓄積している日本人の遺伝子多型データを基にしています。そのため、ここで表示している人口頻度が0%だったとしても、日本人には存在しないという訳ではなく、非常に少ない割合で存在している可能性があります。
    </p>

    <ul className="helppage_menu">
      <li className="help_qa"><Link to={{
        pathname: "/help_faq",
        state: { referer: "/help_result" }
      }} onClick={props.switchPageMethod.bind(this, "HelpFaq")}>検査に関するQ&A</Link></li>
      <li className="help_terms"><Link  to={{
        pathname: "/help_dictionary",
        state: { referer: "/help_result" }
      }} onClick={props.switchPageMethod.bind(this, "HelpDic")}>用語集</Link></li>
    </ul>



  </div>
</div>
)

export const HelpFaq = (props) => (

  <div className="wrap">
        <div className="helppage">
          <h2>検査に関するQ&A</h2>
          <h3>学術論文はどのように選択しているのでしょうか？</h3>

          <p>
            日本人のデータを使用した学術論文を優先的に採用しています。 もし、日本人のデータを使用した論文がない場合は、東アジア人（中国人や台湾人など）のデータを採用し、東アジアのデータがない場合は欧米人のデータを採用しています。
            <br />
            <br /> 日本人のデータ　＞　東アジア人のデータ　＞　欧米人のデータ
            <br /><br /> 同じ民族を使用した論文間では、解析に使用したデータの数が多い論文を優先しています。


          </p>
          <h3>解析する遺伝子の選定はどのように行っているのでしょうか？</h3>

          <p>弊社では自社研究所の研究開発チームが以下の基準に従い、選定を行っています。
          </p>

          <p>
            １）日本人のゲノム解析（GWAS）データから、疾患や体質と関連性の高いゲノム領域を抽出します。<br />ゲノム解析では下図のような解析結果が得られます。この図では疾患や体質と関連の高い領域がピークとなって現れます。弊社ではこれらの情報を参考に、解析する領域を選定しています。

          </p>
          <p className="center">
            <img src={require("../images/help/help03.png")}/>
          </p>

          <p>
            ２）各領域から、遺伝的な重複を除いてSNPを選定します。<br />各領域には複数のSNPがあります。それらの中には重複しているものが含まれているため、学術論文や日本人の多型情報を精査しながら、重複を除いていきます。最終的に得られたSNPおよび遺伝子の解析を弊社のサービスで提供しています。

          </p>

          <p>
            ３）遺伝子研究史において重要な遺伝子やSNPを追加します。<br />ゲノム解析で得られたもの以外にも、遺伝子研究史において重要な遺伝子やSNPについても、改めて学術的に精査を行った上で解析対象に追加しています。
          </p>


          <h3>３．検査するSNP数が多ければ多いほど良いものなのでしょうか？</h3>

          <p>
            疾患や体質に関連する部位を過不足なく解析することが重要であると考えています。<br /> SNPの数が多くても、実際には科学的に見て重複があったりする場合もあります。また、SNPの数が少ないと解析する部位が足りず、信頼性の低い結果にしかならない恐れもあります。弊社では上記の基準を元に、自社の研究所に所属する研究員が解析する遺伝子やSNPを厳選しています。
          </p>

          <h3>４．検査の精度はどのくらいですか？</h3>

          <p>弊社では遺伝子の多型が判明した割合を示すCall rateという指標によって解析品質の判定をしております。このCall rateの値は、弊社の遺伝子検査サービスでは約98%とご案内させて頂いております。
          </p>


          <h3>５．再検査になる割合はどのくらいですか？</h3>
          <p>　これまでに弊社で解析した検体のCall rateの分布は以下のようになっています。</p>
          <p className="center">
            <img src={require("../images/help/help04.png")}/>
          </p>
          <p>有償再解析の対象となるCall rateが97%未満、70%以上の割合は0.5%、無償再解析の対象となるCall rateが70%未満の割合は0.27%となっております（2017年9月時点。Genesis Chip4解析分）
          </p>
          <h3>６．遺伝子検査サービスはどこの会社で受けても同じ結果が出るのでしょうか？</h3>

          <p>
            遺伝子検査サービスは大きく分けると<br /><br /> １）遺伝子のタイプを判定する
            <br /> ２）遺伝子のタイプからリスクを評価する
            <br /> という二段階で実施されています。
            <br />
            <br /> １) の遺伝子のタイプを判定する段階は、技術的な誤差の可能性を排除すれば、どこの遺伝子検査サービスを受けても同じ結果が出るはずです。また、その結果は一生涯変わらないと考えられています。<br />
            <br />一方で、２) の遺伝子の型からリスクを評価する段階は、学術論文に記載された数値やリスクの評価方法の違いによって、オッズ比や判定結果が異なる場合があります。また、科学技術の進歩によりアップデートされる部分もこの段階になります。
            <br /> そのため、遺伝子検査サービスを選ぶ際には、
            <br /><br /> １) 確かな遺伝子解析技術を持つ企業を選ぶことと<br /> ２) 最新の学術的知見を採用した製品を選ぶこと　<br />
            <br />の2点がとても重要ということになります。 なお、ジェネシスヘルスケア株式会社では、多数の解析実績と、最新の知見を反映した遺伝子解析サービスのGeneLifeブランド製品を取り揃えております。

          </p>

          <ul className="helppage_menu">
            <li className="help_result"><Link  to={{
              pathname: "/help_result",
              state: { referer: "/help_faq" }
            }} onClick={props.switchPageMethod.bind(this, "HelpHow")}>検査結果ページの見方</Link></li>
            <li className="help_terms"><Link  to={{
              pathname: "/help_dictionary",
              state: { referer: "/help_faq" }
            }} onClick={props.switchPageMethod.bind(this, "HelpDic")}>用語集</Link></li>
          </ul>

        </div>
      </div>

)


export const HelpDic = (props) => (
  <div className="wrap">
        <div className="helppage">
          <h2>用語集</h2>


          <h3>ゲノムとは</h3>

          <p>
            ゲノムとはある生物が持っている全ての遺伝情報のことです。例えば、ヒトゲノムと言うと、ヒトの持つ全ての遺伝情報のことを指します。このような全遺伝情報（ゲノム）を解析することを、ゲノム解析と言います。
          </p>


          <h3>GWAS解析（ゲノムワイド関連解析）とは</h3>
          <p>GWAS解析とは、ゲノム全領域に渡って遺伝子多型を解析したデータを用いて、疾患リスクや体質に影響を与えている遺伝子やゲノム領域を絞り込む統計学的解析手法のことです。この手法を用いると、疾患リスクや体質に関わる領域がピークとなって現れます。
          </p>
          <p className="center">
            <img src={require("../images/help/help05.png")}/>
          </p>
          <h3>遺伝子多型とは</h3>
          <p>遺伝子多型とは、遺伝子の個人差のことです。 　例えば、お酒に強いタイプや弱いタイプはALDH2という遺伝子にある個人差によって生じています。GeneLifeブランド製品ではこのような遺伝子の個人差を解析し、被験者の体質や疾患リスクを判定しています。
          </p>

          <h3>SNP（Single Nucleotide Polymorphism）とは</h3>
          <p>遺伝子多型には、一塩基の違いによって生じるものと、数塩基の違いによって生じるもの、欠失や挿入によるものなどがあります。この中で一塩基の違いによって生じる遺伝子多型をSNPと言います。</p>

          <h3>オッズ比とは</h3>
          <p>オッズ比とは、対象となる遺伝子型を持つ集団に対して、あなたと同じ遺伝子型を持つ人が発症した比率を表す数値です。オッズ比が1より大きいほど遺伝的に高いリスクになります。
          </p>
          <p className="center">
            <img src={require("../images/help/help06.png")}/>
          </p>
          <p>上図では、Bタイプの人は、Aタイプの人と比べて、オッズ比3.5倍で疾患になりやすい傾向があると判定されます</p>

          <h3>Call rateとは</h3>

          <p>
            マイクロアレイなどの大規模遺伝子解析技術を用いると、一度にたくさんの遺伝子多型が決定できます。このとき、遺伝子多型が判明した数の割合のことをCall rateと言います。<br /><br />
            Call rate=（遺伝子多型が判明した数）／（解析を試みた遺伝子多型の数）<br /><br />
            弊社で使用している54万個以上の遺伝子多型を判定するマイクロアレイを使用した際、Call rateは約98%となっています。つまり、54万のうちおよそ53万弱の遺伝子多型が判定できる計算になります。


          </p>


          <ul className="helppage_menu">
            <li className="help_result"><Link  to={{
              pathname: "/help_result",
              state: { referer: "/help_dictionary" }
            }} onClick={props.switchPageMethod.bind(this, "HelpHow")}>検査結果ページの見方</Link></li>
            <li className="help_qa"><Link  to={{
              pathname: "/help_faq",
              state: { referer: "/help_dictionary" }
            }} onClick={props.switchPageMethod.bind(this, "HelpFaq")}>検査に関するQ&A</Link></li>
          </ul>

        </div>
      </div>
)



// WEBPACK FOOTER //
// ./src/components/Help.js